module.exports = __webpack_public_path__ + "media/images/norconsult_logo-5d0e042c.png";